import React, {useEffect, useState} from 'react';
import {ReactComponent as ArrayIcon} from '../../../../../../assets/main/groups/main-table/array.svg';
import {ReactComponent as ArrayDownIcon} from '../../../../../../assets/i/checked-icon.svg';
import {Link, NavLink, useParams} from "react-router-dom";
import {useAppDispatch, useAppSelector} from "common/hook";
import {ROLE_DEMO_STUDENT, ROLE_HR, ROLE_STUDENT, ROLE_TEACHER} from "entities/constants/constants";
import {Preloader} from "components/layout/preloader/Preloader";
import {NothingYetMessage} from "../../../../personal-cabinet/nothing-yet-message/NothingYetMessage";

import {fetchLessonsByGroupsId} from "features/model/service/groups/groups-lessons/fetchLessonsByGroupsId";
import {setMeetingURL} from "features/model/slice/groups/botton-lesson/joinMeetingSlice";
import {startLesson} from "features/model/service/lessons/lessons-button/start-lesson/startLesson";
import {startMeeting} from "features/model/service/lessons/lessons-button/start-meeting/startMeeting";
import {joinMeeting} from "features/model/service/lessons/lessons-button/join-meeting/joinMeeting";
import {fetchLessonsDemo} from "features/model/service/lessons/lessons-demo/fetchLessonsDemo";
import {fetchLessonsId} from "features/model/service/groups/lessons/fetchLessonsId";
import {singUpMeeting} from "features/model/service/lessons/lessons-demo/sign-up-meeting/signUpMeeting";


interface ILessonItem {
    currentPage: number;
    currentFrom: string;
    currentTo: string;
}

export const LessonItem = ({currentPage, currentFrom, currentTo}: ILessonItem) => {
    const dispatch = useAppDispatch()
    const roleType = useAppSelector((state) => state.role.roleType);
    const LessonsData = useAppSelector((state) => state.groupsLessons.lessons);
    const lessonPagination = useAppSelector((state) => state.groupsLessons.pagination)

    const {page, pageSize, pageCount} = lessonPagination
    const isTeacher = roleType === ROLE_TEACHER;
    const isLoading = useAppSelector((state) => state.groupsLessons.IsLoading);
    const meetingURLData = useAppSelector(state => state.joinMeeting.meetingURL)
    const [isLoadingMeeting, setIsLoadingMeeting] = useState(false);
    const startingSoon = useAppSelector((state) => state.groupsLessons.startingSoon);

    const {groupId} = useParams();


    // для измения статуса
    useEffect(() => {
        if (roleType === ROLE_STUDENT || roleType === ROLE_DEMO_STUDENT) {
            if (startingSoon) {
                const intervalId = setInterval(() => {
                    dispatch(fetchLessonsByGroupsId({
                        groupId: groupId,
                        page: currentPage - 1,
                        from: currentFrom,
                        to: currentTo
                    }));
                }, 10000);

                return () => clearInterval(intervalId);
            }
        }
    }, [startingSoon]);


    const joinMeetingHandler = async (lessonsId: string | undefined | number) => {
        if (lessonsId) {
            setIsLoadingMeeting(true);
            await dispatch(joinMeeting(lessonsId));
            if (roleType === 'student-demo') {
                dispatch(fetchLessonsDemo({}));
            }
            setIsLoadingMeeting(false);
        }
    };

    const startLessonHandler = async (lessonsId: string | undefined | number) => {
        setIsLoadingMeeting(true);
        await dispatch(startLesson(lessonsId));
        await dispatch(fetchLessonsByGroupsId({groupId, page}));
        setIsLoadingMeeting(false);

    }
    const joinSingUpMeeting = async (lessonsId: number) => {
        setIsLoadingMeeting(true);
        if (lessonsId) {
            await dispatch(singUpMeeting(lessonsId));
        }
        await dispatch(fetchLessonsDemo({}));
        setIsLoadingMeeting(false);
    };

    const startMeetingHandler = async (lessonsId: string | undefined | number) => {
        if (lessonsId) {
            setIsLoadingMeeting(true);
            await dispatch(startMeeting(lessonsId));
            await dispatch(fetchLessonsByGroupsId({groupId, page}));
            setIsLoadingMeeting(false);
        }
    };

    useEffect(() => {
        if (meetingURLData) {
            window.open(meetingURLData, '_blank');
            dispatch(setMeetingURL(""))
        }
    }, [meetingURLData]);



    return (
        <>
            {isLoading ? (
                <Preloader/>
            ) : LessonsData.length > 0 ? (
                LessonsData.map((lesson) => {
                    return (
                        <div className="row" key={lesson.id}>
                            <div className="col lesson-col full-width-mobile">
                                <span className="col-title">Занятие</span>
                                <p>
                                    <Link to={`/groups/${groupId}/lessons/${lesson.id}`}>{lesson.title}</Link>
                                </p>

                                {lesson.hasHomework && (
                                    <span className="homework-status">
                                        Домашнее задание{' '}
                                        {roleType === ROLE_TEACHER && (
                                            <>
                                                {typeof lesson.homeworksDone === 'boolean' ? (
                                                    lesson.homeworksDone ? (
                                                        <span className="complited-count dark">
                                                        <ArrayDownIcon/>
                                                        </span>
                                                    ) : null
                                                ) : (
                                                    <span className="complited-count dark">
                                                         {`+${lesson.homeworksDone}`}
                                                    </span>
                                                )}
                                            </>
                                        )}
                                    </span>
                                )}
                                {roleType === ROLE_TEACHER &&
                                    !lesson.published && (
                                        <span className="homework-status">
                                             <span style={{color: 'red'}}>
                                                 Draft
                                             </span>
                                        </span>
                                    )
                                }
                            </div>
                            <div className="col status-col full-width-mobile">
                                <span className="col-title">Статус</span>
                                {lesson.status === 'new' ? (
                                    <p className="status-item">Новое</p>
                                ) : lesson.status === 'inProgress' ? (
                                    <p className="status-item in-progress">Занятие идёт</p>
                                ) : (
                                    <p className="status-item completed">Завершено</p>
                                )}
                            </div>
                            <div className="col lesson-time-col full-width-mobile">
                                <span className="col-title">Время занятия</span>
                                <time className="time">{lesson.dateTime}</time>
                            </div>

                            {
                                roleType !== ROLE_HR && (
                                    <div className="col btn-col full-width-mobile">
                                        {lesson.status === 'new' && isTeacher ? (
                                            <button
                                                onClick={() => startLessonHandler(lesson.id)}
                                                className={`btn secondary${isLoadingMeeting ? ' disabled' : ''}`}
                                                disabled={isLoadingMeeting}
                                            >
                                                <span>{isLoadingMeeting ? 'Загрузка...' : 'Начать занятие'}</span>
                                            </button>
                                        ) : (lesson.status === 'inProgress' && lesson.meetingIsRunning && isTeacher) ? (
                                            <button
                                                onClick={() => joinMeetingHandler(lesson.id)}
                                                className={`in-progress btn secondary${isLoadingMeeting ? ' disabled' : ''}`}
                                                disabled={isLoadingMeeting}
                                            >
                                                <span>{isLoadingMeeting ? 'Загрузка...' : 'Войти в занятие'}</span>
                                            </button>
                                        ) : (lesson.status === 'inProgress' && !lesson.meetingIsRunning  && isTeacher) ? (
                                                <button
                                                    onClick={() => startMeetingHandler(lesson.id)}
                                                    className={`in-progress btn secondary${isLoadingMeeting ? ' disabled' : ''}`}
                                                    disabled={isLoadingMeeting}
                                                >
                                                    <span>{isLoadingMeeting ? 'Загрузка...' : 'Создать комнату'}</span>
                                                </button>
                                            )
                                            : lesson.status === 'new' ? (
                                                    <button
                                                        onClick={() => joinMeetingHandler(lesson.id)}
                                                        className={`btn expect-left`}
                                                        disabled={true}
                                                    >
                                                        <span className='expect-left'>Ожидайте начала занятия</span>
                                                    </button>
                                                )
                                                : lesson.status === 'inProgress' ? (
                                                        <button
                                                            onClick={() => joinMeetingHandler(lesson.id)}
                                                            className={`btn expect-left`}
                                                            disabled={!lesson.meetingIsRunning}
                                                        >
                                                            <span className='expect-left'>Войти в занятие</span>
                                                        </button>
                                                    )
                                                    : null}
                                    </div>
                                )
                            }

                            <div className="col btn-link-col">
                                <NavLink
                                    style={{borderBottom: 'none', textShadow: 'none'}}
                                    className="circle-arrow-btn"
                                    to={`/groups/${groupId}/lessons/${lesson.id}`}
                                >
                                    <ArrayIcon/>
                                </NavLink>
                            </div>
                        </div>
                    )
                        ;
                })
            ) : (
                <NothingYetMessage/>
            )}
        </>
    );
};
